import get from 'lodash/get';

/**
 * True if the current logged in user has Mokapos access.
 *
 * @param {Object} state The Redux state.
 * @returns {boolean}
 */
export default function isMokaposUser(state) {
  return get(state, ['moka', 'user', 'business', 'is_mokapos_user'], false);
}
